const webinarRelatedSection = $('#related-section');
const webinarRelatedCards = webinarRelatedSection.find('.related-list-card');

const setWebinarRelatedCards = () => {
  webinarRelatedCards.each(function () {
    const cardPersonParent = $(this).find('.webinar-related-card-photos-parent');
    const cardPersonOverflow = $(this).find('.webinar-related-card-photos-overflow');
    const cardPersonPhotos = $(this).find('.webinar-related-card-multiply-photo');
    const personPhotosCount = cardPersonPhotos.length;
    const photoWidth = pxToVw(cardPersonPhotos.eq(0).outerWidth());
    const photoHeight = pxToVw(cardPersonPhotos.eq(0).outerWidth());
    const photoOffset = isDesktop() ? 2 : isTablet() ? 3.776 : 6.389;
    if (personPhotosCount != 0) {
      cardPersonOverflow.width(
        `${photoWidth * personPhotosCount - (photoWidth - photoOffset) * (personPhotosCount - 1)}vw`
      );
      cardPersonOverflow.height(`${photoHeight}vw`);
      cardPersonPhotos.each(function (index) {
        $(this).css({
          left: `${photoOffset * index}vw`,
          'z-index': `${personPhotosCount * 100 - index}`,
        });
      });
    } else {
      gsap.set(cardPersonParent, { display: 'none' });
    }
  });
};

const changeCardHover = () => {
  const bigCardHeight = pxToVw(webinarRelatedCards.eq(0).height());
  const relatedContent = webinarRelatedSection.find('.related-section-content');
  gsap.set(relatedContent, { height: `${bigCardHeight}vw` });
  let currentCard = 0;
  if (isDesktop()) {
    webinarRelatedCards.on('mouseenter', function () {
      const to = $(this).index();
      if (to != currentCard) {
        const currentCardImage = webinarRelatedCards.eq(currentCard).find('.related-list-page-image');
        const toCardImage = webinarRelatedCards.eq(to).find('.related-list-page-image');
        gsap.to(currentCardImage, {
          width: '23.625vw',
          height: '15.125vw',
          duration: 0.633,
          ease: 'pageInEasing',
        });
        gsap.to(toCardImage, {
          width: '47.813vw',
          height: '30.625vw',
          duration: 0.633,
          ease: 'pageInEasing',
        });
        currentCard = to;
      }
    });
  } else {
    webinarRelatedCards.off('mouseenter');
    const cardImages = webinarRelatedCards.find('.related-list-page-image');
    gsap.set([relatedContent, cardImages], {
      clearProps: 'all',
    });
  }
};

const webinarRelatedIn = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const webinarRelatedTL = gsap.timeline({ paused: true });

  webinarRelatedTL.add(
    animateSectionTopperIn({
      sectionParent: webinarRelatedSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );

  webinarRelatedCards.each(function (index) {
    webinarRelatedTL.add(addElementInAnimation($(this), '100%', 1, 0).play(), 0.1 * index + 0);
  });

  return webinarRelatedTL;
};

initWebinarRelated = () => {
  setWebinarRelatedCards();
  $(window).on('deviceChange', function () {
    setWebinarRelatedCards();
    changeCardHover();
  });
  const webinarRelatedTL = isDesktop() ? webinarRelatedIn() : false;

  ScrollTrigger.create({
    trigger: webinarRelatedSection,
    start: 'top top+=120%',
    end: 'top top',
    once: true,
    onEnter: () => {
      isDesktop() ? changeCardHover() : false;
    },
    onUpdate: (self) => {
      webinarRelatedTL ? webinarRelatedTL.progress(self.progress) : false;
    },
  });
}

/*
$(window).on('load', () => {
  initWebinarRelated();
});
*/

addSectionObserver(webinarRelatedSection, initWebinarRelated);